import Lookup from 'src/componentes/select2';

const StatusBaselineLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/StatusBaselineLookup"
    {...rest}
  />
);

export default StatusBaselineLookup;
